import { render, staticRenderFns } from "./index.backup.vue?vue&type=template&id=740443ce&"
import script from "./index.backup.vue?vue&type=script&lang=js&"
export * from "./index.backup.vue?vue&type=script&lang=js&"
import style0 from "./index.backup.vue?vue&type=style&index=0&id=740443ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports